import { CatHeading } from '@blocks-react/components/Heading';
import { ProductCardSpecificationsLabelProps } from '../types';

export const ProductCardSpecificationsLabel = ({
  children
}: ProductCardSpecificationsLabelProps) => {
  return <CatHeading variant="label">{children}</CatHeading>;
};

export default ProductCardSpecificationsLabel;
